import { createRouter, createWebHistory } from 'vue-router';

import { authMiddleware, pageTitleMiddleware, toastsMiddleware } from '@/router/middleware';
import anonymousRoutes from '@/router/routes/anonymous';
import authenticatedRoutes from '@/router/routes/authenticated';

const scrollBehavior = (to, from, savedPosition) => {
  // Scroll to top if on same route
  if (to.name === from.name) {
    to.meta?.scrollPos && (to.meta.scrollPos.top = 0);

    return { left: 0, top: 0 };
  }

  return savedPosition ||
        to.meta?.scrollPos ||
        { left: 0, top: 0 };
};

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...authenticatedRoutes,
    ...anonymousRoutes,
  ],
  scrollBehavior,
});

router.afterEach(pageTitleMiddleware);
router.afterEach(toastsMiddleware);
router.beforeEach(authMiddleware);
